import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'crg-newreservation',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  constructor(public authServc: AuthenticationService) { }

  ngOnInit() {
  }

  close(alert: any) {
    // this.alert = null;
  }

}
